import { render, staticRenderFns } from "./SearchResultHeader.vue?vue&type=template&id=647124cf&scoped=true&"
import script from "./SearchResultHeader.vue?vue&type=script&lang=js&"
export * from "./SearchResultHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultHeader.vue?vue&type=style&index=0&id=647124cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647124cf",
  null
  
)

export default component.exports